import React, { useEffect, useRef, useState } from 'react';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import TurndownService from 'turndown';
import { EditorState, ContentState, convertToRaw, convertFromHTML, Modifier } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
// const createState = (text: any) => {
//     return EditorState.createWithContent(ContentState.createFromText(text));
// };

const SystemPromptModal = ({ active, visible, setVisible, prompt, handleCloseSystemPrompt, label, handelPrompt, showSystemPromptModal }: any) => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const editorRef: any = useRef(null);

    useEffect(() => {
        // Focus on the editor when it mounts
        // editorRef.current.focusEditor();
        // if (editorRef && editorRef.current) {
        //     editorRef?.current.focus();
        // }
        const timeoutId = setTimeout(() => {
            const editor: any = document.querySelector('.public-DraftEditor-content');
            if (editor) {
                editor.focus();
            }
        }, 100); // Adjust the delay time as needed

        // Clear the timeout when the component unmounts
        return () => clearTimeout(timeoutId);
    }, []);

    // Function to convert editor content to Markdown
    const convertToHtml = () => {
        const contentState = editorState.getCurrentContent();
        const rawContentState = convertToRaw(contentState);
        const html = draftToHtml(rawContentState);
        return html;
    };

    // Function to convert HTML to Markdown
    const convertToMarkdown = (html: any) => {
        let turndownService = new TurndownService();
        // Custom rules for replacements
        turndownService.addRule('strong', {
            filter: ['strong'],
            replacement: (content) => `**${content}**`,
        });

        turndownService.addRule('em', {
            filter: ['em'],
            replacement: (content) => `*${content}*`,
        });

        // turndownService.addRule('underline', {
        //     filter: ['ins'],
        //     replacement: (content) => `__${content}__`,
        // });

        // turndownService.addRule('br', {
        //     filter: ['br'],
        //     replacement: () => '\\n',
        // });

        // Convert HTML to Markdown
        const convertedMarkdown = turndownService.turndown(html);

        return convertedMarkdown;
    };

    // const handleEditorStateChange = (editorState: any) => {
    //     // const data = ContentState.createFromText(
    //     //     editorState
    //     // )
    //     //  EditorState.createWithContent(data)
    //     setEditorState(editorState);
    // };

    useEffect(() => {
        if (prompt !== "") {
            // const result2 = JSON.stringify("Details of Upside Down Peri Bottle - Pink:\n- Name: 100000016\n- Legacy SKU Name: MS-MWBL-NS-US00\n- UPC Code: 851877006639\n- MSRP (USD): $15.99\n- Sales Description: Upside Down Peri Bottle - Pink\n\nDetails of Nailfrida The Snipperclipper Solo:\n- Name: 100000027\n- Legacy SKU Name: 018\n- UPC Code: 851877006103\n- MSRP (USD): $9.99\n- Sales Description: Nailfrida The Snipperclipper Solo")
            // const result = JSON.parse(result2).trim();
            const result = JSON.parse(prompt).trim();
            // Set default content in Markdown format
            const resultWithBreaks = result.replace(/\n/g, '<br />').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\*(.*?)\*/g, "<em>$1</em>");
            const temp2 = resultWithBreaks
            const blocksFromHTML = convertFromHTML(`<div>${resultWithBreaks}</div>`);
            const contentState = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap
            );
            // const contentState = ContentState.createFromText(result);
            const editorStateWithMarkdown = EditorState.createWithContent(contentState);
            setEditorState(editorStateWithMarkdown);
        }
    }, [prompt, showSystemPromptModal]);


    const handleReturn = (e: { shiftKey: any; keyCode: number; }, editorState: EditorState) => {
        // If Enter key is pressed, insert a soft line break
        if (!e.shiftKey && e.keyCode === 13 || e.shiftKey && e.keyCode === 13) {
            const contentState = editorState.getCurrentContent();
            const selectionState = editorState.getSelection();

            const newContentState = Modifier.insertText(contentState, selectionState, '\n');
            const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');

            setEditorState(newEditorState);
            return true; // Return true for handled
        }
        // Otherwise, return false for not-handled
        return false;
    }

    // Handle pasted text to fix line breaks
    const handlePastedText = (text: string, html: string, editorState: EditorState, onChange: (editorState: EditorState) => void) => {
        // Replace consecutive double line breaks with a unique token
        const newText = text.replace(/\n\n/g, '\n\u200B\n');
        const contentState = Modifier.replaceText(
            editorState.getCurrentContent(),
            editorState.getSelection(),
            newText,
        );
        onChange(EditorState.push(editorState, contentState, 'insert-characters'));
        return true;
    };

    // Run only once on component mount
    const saveData = () => {
        const raw = convertToMarkdown(convertToHtml()).replace(/\\/g, '')
        // const raw = convertToMarkdown(convertToHtml()).replace(/\\\\/g, '')
        // const raw = JSON.stringify(convertToMarkdown(convertToHtml())).replace(/\\\\/g, '')
        handelPrompt(raw)
        setVisible(false);
    }

    // Define a custom toolbar with only bold, italic, and underline options
    const customToolbarOptions = {
        options: ['inline'],
        // options: ['inline', 'blockType', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'image', 'remove', 'history'],
        inline: {
            options: ['bold', 'italic'],
            // options: ['bold', 'italic', 'underline'],
        },
        blockType: {
            inDropdown: true,
            options: ['Normal'],
        },
        list: {
            inDropdown: false,
            options: ['unordered', 'ordered'],
        },
        textAlign: {
            inDropdown: false,
        },
        colorPicker: {
            inDropdown: false,
        },
        link: {
            inDropdown: false,
        },
        emoji: {
            inDropdown: false,
        },
        image: {
            inDropdown: false,
        },
        remove: {
            inDropdown: false,
        },
        history: {
            inDropdown: false,
        },
    };

    const customHeader = (
        <div className="flex align-items-center gap-2">
            {label}
        </div>
    );

    return (
        <Sidebar position="right" header={customHeader} visible={visible} onHide={handleCloseSystemPrompt} className='form-sidebar add-config-sidebar' style={{ width: '810px' }}>
            <div className="form-sidebar-body">
                <Editor
                    ref={editorRef}
                    editorState={editorState}
                    toolbarClassName="editor-toolbar"
                    wrapperClassName="editor-wrapper"
                    editorClassName="editor public-DraftEditor-content"
                    onEditorStateChange={(newEditorState) =>
                        setEditorState(newEditorState)
                    }
                    toolbar={customToolbarOptions}
                    wrapperStyle={{ overflow: 'auto' }}
                    spellCheck
                    placeholder="Type initial text..."
                    handleReturn={handleReturn}
                    handlePastedText={handlePastedText}
                />
            </div>
            <div className='form-sidebar-footer'>
                <Button className='grey-outline-btn mr-3' label='Cancel' onClick={handleCloseSystemPrompt}></Button>
                <Button className='outline-active-btn' label='Save' onClick={() => saveData()}></Button>
            </div>
            {/* <div className="modal-footer justify-content-center border-top-0 pb-4">
                <button type="button" className="btn btn-primary me-2" data-bs-dismiss="modal" >Save</button>
                <button type="button" className="btn btn-outline-dark ms-2" data-bs-dismiss="modal" >Cancel</button>
            </div> */}
        </Sidebar>
    )
}
export default SystemPromptModal